import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-salad-dressings',
  templateUrl: './salad-dressings.component.html',
  styleUrls: ['./salad-dressings.component.css']
})
export class SaladDressingsComponent implements OnInit {

  @Input() dressings: [];
  @Input() dressingHeight;

  constructor() { }

  ngOnInit() {
    this.dressings = [];
  }

}
